import { cweaClient } from '../clients/api-proxy-browser-client';
import { CWEA_ENDPOINTS } from '../constants';
import type { CustomerEligibilityResponse, CustomerPetEligibilityResponse } from '@libs/common-types';
import type {
    AccountCommonErrorResponse,
    UpdateAppointmentStatusRequest,
    UpdateAppointmentStatusReponse,
    GetAppointmentResponse,
    AppointmentPackagesSuccessfulResponse,
} from '@libs/common-next';

export async function getCustomerBookingEligibility() {
    const url = CWEA_ENDPOINTS.appointments.getCustomerBookingEligibility;
    return await cweaClient.get<CustomerEligibilityResponse>(url, { useOldFetch: true });
}

export async function getPetBookingEligibility(petId: string) {
    const url = CWEA_ENDPOINTS.appointments.getPetBookingEligibility(petId);
    return await cweaClient.get<CustomerPetEligibilityResponse>(url, { useOldFetch: true });
}

export async function updateAppointmentStatus(body: UpdateAppointmentStatusRequest) {
    const url = CWEA_ENDPOINTS.appointments.updateAppointmentStatus;
    const response = await cweaClient.put<
        AccountCommonErrorResponse | UpdateAppointmentStatusReponse,
        UpdateAppointmentStatusRequest
    >(url, {
        body,
        useOldFetch: true,
    });

    if (response === null) {
        throw new Error('Unexpected response');
    }

    if (response && 'statusCode' in response && response.statusCode === 400) {
        throw new Error(`updateAppointmentStatus failed with status code: ${response.statusCode}`);
    }

    if (response && 'success' in response) {
        return response;
    }

    throw new Error('Unexpected response structure');
}

export async function getAppointments() {
    const url = CWEA_ENDPOINTS.appointments.getAppointments;
    const response = await cweaClient.get<GetAppointmentResponse>(url, { useOldFetch: true });

    if (response === null) {
        throw new Error('Unexpected response');
    }

    if (response && 'statusCode' in response && response.statusCode === 400) {
        throw new Error(`getAppointments failed with status code: ${response.statusCode}`);
    }

    if (response && 'appointments' in response) {
        return {
            pastAppointments: response.appointments.past,
            upcomingAppointments: response.appointments.upcoming,
        };
    }

    throw new Error('Unexpected response structure');
}

export async function getPackages() {
    const url = CWEA_ENDPOINTS.appointments.getPackages;
    const response = await cweaClient.get<AccountCommonErrorResponse | AppointmentPackagesSuccessfulResponse>(url, {
        useOldFetch: true,
    });

    if (response === null) {
        throw new Error('Unexpected response');
    }

    if (response && 'statusCode' in response && response.statusCode === 400) {
        throw new Error(`getPackages failed with status code: ${response.statusCode}`);
    }

    if (response && 'result' in response) {
        return response.result.pets.filter(item => item.bundles.length);
    }

    throw new Error('Unexpected response structure');
}
